<script>
  import { loadingStore } from './loading';
</script>

{#if $loadingStore.visible}
  <div
    class="
    fixed inset-0
    z-[10000]
    bg-black/25
    backdrop-blur-[2px]
    flex items-center justify-center
    p-4">
    <div
      class="
  w-[320px]
  max-w-[90vw]
  bg-white
  rounded-xl
  shadow-2xl
  border border-slate-200">
      <div class="p-6">
        <div class="flex justify-center">
          <div class="loader"></div>
        </div>

        <div
          class="
      mt-4
      text-center
      text-sm
      text-slate-700
      font-medium">
          {$loadingStore.text}
        </div>

        {#if $loadingStore.progress !== null}
          <div
            class="
        mt-4
        h-2
        rounded-full
        bg-slate-200
        overflow-hidden">
            <div
              class="progress"
              style="
            width:
            {$loadingStore.progress}%">
            </div>
          </div>

          <div
            class="
        mt-2
        text-center
        text-xs
        text-slate-500">
            {$loadingStore.progress}%
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  .loader {
    width: 46px;
    height: 46px;
    border-radius: 999px;

    border: 4px solid #dbeafe;
    border-top-color: #2563eb;

    animation: spin 0.8s linear infinite;
  }

  .progress {
    height: 100%;
    background: #2563eb;

    transition: width 0.25s ease;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 640px) {
    .loader {
      width: 40px;
      height: 40px;
    }
  }
</style>
